import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { CameraForm } from "app/interfaces/camera-form.interface";

const camerasUrlApi = environment.camerasUrlApi;
const cameraUrlApi = environment.cameraUrlApi;
// const camerasWithFiltersUrlApi = environment.camerasWithFiltersUrlApi;

@Injectable()
export class CameraService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getCamerasDevice(id: number) {
    return this.http
      .request("GET", `${camerasUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  /* getCamerasWithFilter(filters) {
    const params = filters;
    console.log(params);
    return this.http
      .post(`${camerasWithFiltersUrlApi}`, params)
      .pipe(map((resp: any) => resp));
  } */

  getCameraById(id: number) {
    return this.http
      .request("GET", `${cameraUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateCameraById(id: number, cameraModel: CameraForm) {
    const body = cameraModel;
    return this.http
      .request("PUT", `${camerasUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createCamera(idDevice: number, cameraModel: CameraForm) {
    cameraModel.id_device = idDevice;
    const body = cameraModel;
    return this.http
      .request("POST", `${camerasUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteCameraById(id: number) {
    return this.http
      .request("DELETE", `${camerasUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
